import React, { useState } from 'react';
import { ExternalLink, Loader2, Ruler } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { errMsg } from '@/services/staffAttendanceApi';
import { ewbApi } from '@/services/ewayBillApi';

const P2P = 'https://ewaybillgst.gov.in/Others/P2PDistance.aspx';

/** Portal rejected the distance (more than 10% over its PIN-to-PIN km): type the portal's km — remembered for this PIN pair. */
export const FixDistanceBox = ({ b, onChanged }) => {
  const [open, setOpen] = useState(false);
  const [km, setKm] = useState('');
  const [busy, setBusy] = useState(false);
  const pins = `${b.from?.pincode || '—'} → ${b.to?.pincode || '—'}`;
  const save = () => {
    setBusy(true);
    ewbApi.fixDistance(b.id, Number(km)).then((x) => {
      toast.success(`Distance ${x.part_b.distance_km} km saved${x.pin_pair ? ` and remembered for PIN ${x.pin_pair}` : ''} — download the portal JSON again for this bill`);
      setOpen(false); setKm(''); onChanged(x);
    }).catch((e) => toast.error(errMsg(e, 'Could not change the distance'))).finally(() => setBusy(false));
  };
  if (!open) {
    return (
      <Button size="sm" variant="outline" onClick={() => { setKm(String(b.part_b?.distance_km ?? '')); setOpen(true); }} data-testid="ewb-fix-distance-btn">
        <Ruler className="w-4 h-4 mr-1" />Fix distance
      </Button>
    );
  }
  return (
    <div className="space-y-2 rounded-md border border-amber-200 bg-amber-50/60 p-3" data-testid="ewb-fix-distance-box">
      <p className="text-xs text-amber-900">The portal accepts at most 10% more than its own PIN-to-PIN distance. Check PIN {pins} on the portal, type its km, then download the portal JSON for this bill again.</p>
      <div className="flex flex-wrap items-center gap-2">
        <Input value={km} onChange={(e) => setKm(e.target.value.replace(/\D/g, '').slice(0, 4))} inputMode="numeric" className="h-8 w-28 bg-white" placeholder="km" data-testid="ewb-fix-distance-input" />
        <span className="text-xs text-gray-500">km (was {b.part_b?.distance_km} km)</span>
        <a href={P2P} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-xs text-[#2D5F4F] underline" data-testid="ewb-fix-distance-p2p-link">
          Portal PIN-to-PIN distance<ExternalLink className="w-3 h-3" /></a>
        <div className="ml-auto flex gap-2">
          <Button size="sm" variant="ghost" onClick={() => setOpen(false)} disabled={busy} data-testid="ewb-fix-distance-cancel">Cancel</Button>
          <Button size="sm" onClick={save} disabled={busy || !(Number(km) >= 1)} className="bg-[#2D5F4F] hover:bg-[#234A3D]" data-testid="ewb-fix-distance-save">
            {busy && <Loader2 className="w-4 h-4 mr-1 animate-spin" />}Save distance</Button>
        </div>
      </div>
    </div>
  );
};

export default FixDistanceBox;
